/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x3418=['enableCommand','editor','TrackChangesEditing','get','plugins','has'];(function(_0x85f1eb,_0x341877){const _0x3093d0=function(_0x295f6d){while(--_0x295f6d){_0x85f1eb['push'](_0x85f1eb['shift']());}};_0x3093d0(++_0x341877);}(_0x3418,0x87));const _0x3093=function(_0x85f1eb,_0x341877){_0x85f1eb=_0x85f1eb-0x0;let _0x3093d0=_0x3418[_0x85f1eb];return _0x3093d0;};import{Plugin as _0x59b73b}from'ckeditor5/src/core';export default class pt extends _0x59b73b{['afterInit'](){const _0x3b40bb=this[_0x3093('0x4')],_0x469e3f=_0x3b40bb[_0x3093('0x1')][_0x3093('0x0')](_0x3093('0x5'));_0x3b40bb['plugins'][_0x3093('0x2')]('UndoEditing')&&(_0x469e3f[_0x3093('0x3')]('undo'),_0x469e3f['enableCommand']('redo'));}}